<script>
    import axios from 'axios'
    import AppMixin from './../../../mixins/AppMixin'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import Checkbox from "primevue/checkbox";
    import InputNumber from "primevue/inputnumber";
    import Divider from "primevue/divider";
    import RadioButton from "primevue/radiobutton";
    import AdaptersDropdown from '../../../component/adapters/Dropdown.vue';

    export default {
        mixins: [AppMixin],
        data() {
            return {
                loading: false,
                error: null,
                model: {},
                dropdownOptions: [
                    {caption: this.$t('lang.main.select'), value: ''},
                    {caption: this.$t('lang.main.yes'), value: 1},
                    {caption: this.$t('lang.main.no'), value: 0},
                ],
            }
        },
        props: ["name", "reportRid", "type", "target", "config"],
        methods: {
            save() {
                let self = this;

                if (!this.model.keysFromOrganic && !this.model.keysFromContext) {
                    this.error = this.$t('lang.group_report.keys_type_err');
                    return false;
                }

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: {
                        config: self.model,
                    }
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.config.ids = null;
                this.error = null
            },
            onOpen() {
                if(this.target == "all"){
                    this.model = {
                        keysFromOrganic: true,
                        keysFromOrganicOr: false,
                        keysFromContext: true,
                        keysFromContextOr: false,
                    };

                }else{
                    this.model = {
                        keysFromOrganic: this.target == "organic",
                        keysFromOrganicOr: false,
                        keysFromContext: this.target == "context",
                        keysFromContextOr: false,
                    };

                }

            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/group/' + this.type + '/filter/' + this.reportRid;
            },
            btnModalLabel(){
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            filterLabel(){
                return this.type === 'import' ? this.$t('lang.group_report.add_keys_run') : this.$t('lang.group_report.delete_keys_run');
            },
            resultOrganicStr(){
                let result = [], interResult = [];

                let config = {
                    [this.$t('lang.main.f_weight_label')]: [
                        {condition: '>=', field: 'organicWeightFrom'}, {condition: '<=', field: 'organicWeightTo'},
                    ],
                    [this.$t('lang.main.f_ws_label')]: [
                        {condition: '>=', field: 'organicWsFrom'}, {condition: '<=', field: 'organicWsTo'},
                    ]
                };

                if(this.isYandex){
                    config[this.$t('lang.main.f_wsk_label')] = [
                        {condition: '>=', field: 'organicWskFrom'}, {condition: '<=', field: 'organicWskTo'},
                    ];
                }

                config = {
                    ...config,

                    [this.$t('lang.main.f_key_count_label')]: [
                        {condition: '>=', field: 'organicNumWordsFrom'}, {condition: '<=', field: 'organicNumWordsTo'},
                    ],
                    [this.$t('lang.main.f_top_label')]: [
                        {condition: '=', field: 'organicIsGeo', type: 'bool'},
                    ],
                    [this.$t('lang.main.f_quest_label')]: [
                        {condition: '=', field: 'organicIsQuestion', type: 'bool'},
                    ]
                };

                for (let prop in config) {
                    config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== ""){
                            if(c.field && c.type === 'bool'){
                                interResult.push(prop + " " + c.condition + " " + (this.model[c.field] === 1 ? this.$t('lang.main.yes') : this.$t('lang.main.no')));
                            }else{
                                interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                            }
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }


                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.keysFromOrganicOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")"
            },
            resultContextStr() {
                let result = [], interResult = [];

                let config = {
                    [this.$t('lang.main.f_weight_label')]: [
                        {condition: '>=', field: 'contextWeightFrom'}, {condition: '<=', field: 'contextWeightTo'},
                    ],
                    [this.$t('lang.main.f_ws_label')]: [
                        {condition: '>=', field: 'contextWsFrom'}, {condition: '<=', field: 'contextWsTo'},
                    ],
                    [this.$t('lang.main.f_wsk_label')]: [
                        {condition: '>=', field: 'contextWskFrom'}, {condition: '<=', field: 'contextWskFrom'},
                    ]
                };

                if(this.isYandex){
                    config[this.$t('lang.main.f_wsk_label')] = [
                        {condition: '>=', field: 'contextWskFrom'}, {condition: '<=', field: 'contextWskFrom'},
                    ];
                }

                config = {
                    ...config,
                    [this.$t('lang.main.f_key_count_label')]: [
                        {condition: '>=', field: 'contextNumWordsFrom'}, {condition: '<=', field: 'contextNumWordsTo'},
                    ],
                    [this.$t('lang.main.f_top_label')]: [
                        {condition: '=', field: 'contextIsGeo', type: 'bool'},
                    ],
                    [this.$t('lang.main.f_quest_label')]: [
                        {condition: '=', field: 'contextIsQuestion', type: 'bool'},
                    ]
                };

                for (let prop in config) {
                    config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== ""){
                            if(c.field && c.type === 'bool'){
                                interResult.push(prop + " " + c.condition + " " + (this.model[c.field] === 1 ? this.$t('lang.main.yes') : this.$t('lang.main.no')));
                            }else{
                                interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                            }
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }

                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.keysFromContextOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")"
            }
        },
        components: {
            AdaptersDialog,
            Checkbox,
            InputNumber,
            Divider,
            RadioButton,
            AdaptersDropdown,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.group_report.delete_key_by_filter')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <p class="pt-0">{{ $t('lang.main.f_rules') }}</p>
            <div class="field-checkbox">
                <Checkbox v-model="model.keysFromOrganic" inputId="fromOrganic" binary />
                <label for="fromOrganic">{{ $t('lang.main.f_keys_organic') }}</label>
            </div>
            <template v-if="model.keysFromOrganic">
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicWeightFrom">{{$t('lang.main.f_weight_label')}} {{$t('lang.main.f_from')}}</label>
                            <InputNumber v-model.number="model.organicWeightFrom" inputId="organicWeightFrom" :min="1" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicWeightTo">{{$t('lang.main.f_weight_label')}} {{$t('lang.main.f_to')}}</label>
                            <InputNumber v-model.number="model.organicWeightTo" inputId="organicWeightTo" :max="50" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicWsFrom">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_from')}}
                            </label>
                            <InputNumber v-model.number="model.organicWsFrom" inputId="organicWsFrom" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicWsTo">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_to')}}
                            </label>
                            <InputNumber v-model.number="model.organicWsTo" inputId="organicWsTo" />
                        </div>
                    </div>
                    <template v-if="isYandex">
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="organicWskFrom">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                                <InputNumber v-model.number="model.organicWskFrom" inputId="organicWskFrom" :min="0" />
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="organicWskTo">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_to')}}</label>
                                <InputNumber v-model.number="model.organicWskTo" inputId="organicWskTo" />
                            </div>
                        </div>
                    </template>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicNumWordsFrom">{{$t('lang.main.f_key_count_label')}} {{$t('lang.main.f_from')}}</label>
                            <InputNumber v-model.number="model.organicNumWordsFrom" inputId="organicNumWordsFrom" :min="1" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicNumWordsTo">{{$t('lang.main.f_key_count_label')}} {{$t('lang.main.f_to')}}</label>
                            <InputNumber v-model.number="model.organicNumWordsTo" inputId="organicNumWordsTo" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label>{{$t('lang.main.f_top_label')}}</label>
                            <AdaptersDropdown
                                v-model="model.organicIsGeo"
                                :options="dropdownOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :placeholder="this.$t('lang.main.select')"
                            />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field">
                            <label>{{$t('lang.main.f_quest_label')}}</label>
                            <AdaptersDropdown
                                v-model="model.organicIsQuestion"
                                :options="dropdownOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :placeholder="this.$t('lang.main.select')"
                            />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label>{{filterLabel}}</label>
                            <div class="formgroup-inline">
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromOrganicOr" :value="false" inputId="keysFromOrganicAnd" />
                                    <label for="keysFromOrganicAnd">{{ $t('lang.main.f_rule_and') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromOrganicOr" :value="true" inputId="keysFromOrganicOr" />
                                    <label for="keysFromOrganicOr">{{ $t('lang.main.f_rule_or') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="resultOrganicStr">
                    <div class="grid">
                        <div class="col">
                            <code>{{ resultOrganicStr }}</code>
                        </div>
                    </div>
                </template>
                <Divider />
            </template>

            <div class="field-checkbox">
                <Checkbox v-model="model.keysFromContext" inputId="fromContext" binary />
                <label for="fromContext">{{ $t('lang.main.f_keys_context') }}</label>
            </div>
            <template v-if="model.keysFromContext">
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextWeightFrom">{{$t('lang.main.f_weight_label')}} {{$t('lang.main.f_from')}}</label>
                            <InputNumber v-model.number="model.contextWeightFrom" inputId="contextWeightFrom" :min="1" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextWeightTo">{{$t('lang.main.f_weight_label')}} {{$t('lang.main.f_to')}}</label>
                            <InputNumber v-model.number="model.contextWeightTo" inputId="contextWeightTo" :max="50" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextWsFrom">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_from')}}
                            </label>
                            <InputNumber v-model.number="model.contextWsFrom" inputId="contextWsFrom" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextWsTo">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_to')}}
                            </label>
                            <InputNumber v-model.number="model.contextWsTo" inputId="contextWsTo" />
                        </div>
                    </div>
                    <template v-if="isYandex">
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="contextWskFrom">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                                <InputNumber v-model.number="model.contextWskFrom" inputId="contextWskFrom" :min="0" />
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="contextWskTo">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_to')}}</label>
                                <InputNumber v-model.number="model.contextWskTo" inputId="contextWskTo" />
                            </div>
                        </div>
                    </template>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextNumWordsFrom">{{$t('lang.main.f_key_count_label')}} {{$t('lang.main.f_from')}}</label>
                            <InputNumber v-model.number="model.contextNumWordsFrom" inputId="contextNumWordsFrom" :min="1" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextNumWordsTo">{{$t('lang.main.f_key_count_label')}} {{$t('lang.main.f_to')}}</label>
                            <InputNumber v-model.number="model.contextNumWordsTo" inputId="contextNumWordsTo" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label>{{$t('lang.main.f_top_label')}}</label>
                            <AdaptersDropdown
                                v-model="model.contextIsGeo"
                                :options="dropdownOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :placeholder="this.$t('lang.main.select')"
                            />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field">
                            <label>{{$t('lang.main.f_quest_label')}}</label>
                            <AdaptersDropdown
                                v-model="model.contextIsQuestion"
                                :options="dropdownOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :placeholder="this.$t('lang.main.select')"
                            />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label>{{filterLabel}}</label>
                            <div class="formgroup-inline">
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromContextOr" :value="false" inputId="keysFromContextAnd" />
                                    <label for="keysFromContextAnd">{{ $t('lang.main.f_rule_and') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromContextOr" :value="true" inputId="keysFromContextOr" />
                                    <label for="keysFromContextOr">{{ $t('lang.main.f_rule_or') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="resultContextStr">
                    <div class="grid">
                        <div class="col">
                            <code>{{ resultContextStr }}</code>
                        </div>
                    </div>
                </template>
            </template>
        </template>
    </AdaptersDialog>
</template>
